import { Alert, Button, Form, Space } from "antd";
import type { ReactNode } from "react";

export function EntityFormShell({
  children,
  error,
  saving,
  onCancel
}: {
  children: ReactNode;
  error?: string | null;
  saving?: boolean;
  onCancel: () => void;
}) {
  return (
    <Space direction="vertical" style={{ width: "100%" }} size={12}>
      {error ? <Alert type="error" message={error} showIcon /> : null}
      {children}
      <Form.Item style={{ marginBottom: 0 }}>
        <Space>
          <Button type="primary" htmlType="submit" loading={saving}>Save</Button>
          <Button onClick={onCancel}>Cancel</Button>
        </Space>
      </Form.Item>
    </Space>
  );
}
